import React, { createContext, useState, useEffect, useCallback, useContext, useRef } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCommentDots, faUser, faArrowLeft, faAngleRight, faPaperclip, faSearch, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import firebase from 'firebase';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
} // A type of promise-like that resolves synchronously and supports only one observer


var _iteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";

var _asyncIteratorSymbol =
/*#__PURE__*/
typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator"; // Asynchronously call a function and send errors to recovery continuation


function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

var initialState = {
  sendMessage: function sendMessage() {
    return undefined;
  },
  contacts: undefined,
  onMessage: function onMessage() {
    return undefined;
  },
  getChannel: function getChannel() {
    return undefined;
  },
  notifyTarget: function notifyTarget() {
    return undefined;
  },
  notifications: undefined,
  hasAlert: function hasAlert() {
    return undefined;
  },
  removeTargetNotification: function removeTargetNotification() {
    return undefined;
  },
  user: undefined,
  conversations: undefined,
  counterAlert: function counterAlert() {
    return undefined;
  },
  connection: function connection() {
    return undefined;
  },
  oneContact: false,
  provider: undefined
};
var firebaseChatContext = createContext(initialState);

var FirebaseChatContextProvider = function FirebaseChatContextProvider(_ref) {
  var children = _ref.children,
      users = _ref.users,
      user = _ref.user,
      connection = _ref.connection,
      config = _ref.config;

  var _useState = useState([]),
      contacts = _useState[0],
      setContacts = _useState[1];

  var _useState2 = useState([]),
      conversations = _useState2[0],
      setConversations = _useState2[1];

  var _useState3 = useState([]),
      notifications = _useState3[0],
      setNotifications = _useState3[1];

  var _useState4 = useState([]),
      firebaseUsers = _useState4[0],
      setFirebaseUsers = _useState4[1];

  var _useState5 = useState([]),
      errors = _useState5[0],
      setErrors = _useState5[1];

  var _useState6 = useState(false),
      oneContact = _useState6[0],
      setOneContact = _useState6[1];

  var _useState7 = useState(''),
      provider = _useState7[0],
      setProvider = _useState7[1];

  var getContactType = function getContactType() {
    if (config !== null && config !== void 0 && config.oneContact && (users === null || users === void 0 ? void 0 : users.length) === 1) {
      setOneContact(true);
    }
  };

  useEffect(function () {
    setProvider(config === null || config === void 0 ? void 0 : config.provider);
  }, [config]);
  useEffect(function () {
    getContactType();
  }, [config, users]);
  var db = connection.firestore();
  var hasAlert = useCallback(function () {
    return Object.values(notifications).some(function (n) {
      var _n$content;

      return n === null || n === void 0 ? void 0 : (_n$content = n.content) === null || _n$content === void 0 ? void 0 : _n$content.activeNotification;
    });
  }, [notifications]);
  var counterAlert = useCallback(function () {
    return notifications === null || notifications === void 0 ? void 0 : notifications.reduce(function (accumulator, data) {
      var _data$content;

      if (data !== null && data !== void 0 && (_data$content = data.content) !== null && _data$content !== void 0 && _data$content.activeNotification) {
        return accumulator + 1;
      }

      return accumulator;
    }, 0);
  }, [notifications]);

  var getContacts = function getContacts() {
    setContacts(users);
  };

  var sortContactsByNotifications = function sortContactsByNotifications() {
    var sort = [];
    contacts.map(function (r) {
      var _results$content;

      var results = notifications.find(function (x) {
        return x.id === r.id.toString();
      });

      if (results !== null && results !== void 0 && results.id && results !== null && results !== void 0 && (_results$content = results.content) !== null && _results$content !== void 0 && _results$content.lastMessage) {
        var _results$content2, _results$content3;

        sort.push({
          id: results === null || results === void 0 ? void 0 : results.id,
          name: r.name,
          timestamp: results === null || results === void 0 ? void 0 : (_results$content2 = results.content) === null || _results$content2 === void 0 ? void 0 : _results$content2.timestamp,
          lastMessage: results === null || results === void 0 ? void 0 : (_results$content3 = results.content) === null || _results$content3 === void 0 ? void 0 : _results$content3.lastMessage
        });
      }
    });
    sort.sort(function (a, b) {
      var _b$timestamp, _a$timestamp;

      return ((_b$timestamp = b.timestamp) === null || _b$timestamp === void 0 ? void 0 : _b$timestamp.seconds) - ((_a$timestamp = a.timestamp) === null || _a$timestamp === void 0 ? void 0 : _a$timestamp.seconds);
    });
    setConversations(sort);
  };

  var onMessage = function onMessage(callback, channel) {
    return db.collection((config === null || config === void 0 ? void 0 : config.provider) + "/conversations/" + channel).orderBy("timestamp").onSnapshot(function (querySnapshot) {
      var messages = [];
      querySnapshot.forEach(function (d) {
        return messages.push(d.data());
      });
      callback(messages);
    });
  };

  var createNotificationListener = useCallback(function () {
    if (user) {
      db.collection((config === null || config === void 0 ? void 0 : config.provider) + "/notifications/" + user.id).onSnapshot(function (docSnapshot) {
        var notifiers = [];
        var listContacts = [];
        docSnapshot.docs.map(function (r) {
          var _r$data, _r$data$content;

          notifiers.push({
            id: r.id,
            content: r.data()
          });
          listContacts.push({
            id: r.id,
            timestamp: (_r$data = r.data()) === null || _r$data === void 0 ? void 0 : (_r$data$content = _r$data.content) === null || _r$data$content === void 0 ? void 0 : _r$data$content.timestamp
          });
        });
        setFirebaseUsers(listContacts);
        setNotifications(notifiers);
      });
    }
  }, [user]);
  useEffect(function () {
    sortContactsByNotifications();
  }, [firebaseUsers, notifications]);
  var getChannel = useCallback(function (target) {
    var ids = [user.id, target.id].sort();
    return ids[0] + "-" + ids[1];
  }, [user]);

  var notifyTarget = function notifyTarget(target, content) {
    db.collection("" + (config === null || config === void 0 ? void 0 : config.provider)).doc("notifications").collection("" + target.id).doc("" + user.id).set({
      counter: connection.firestore.FieldValue.increment(1),
      activeNotification: true,
      lastMessage: content,
      timestamp: connection.firestore.FieldValue.serverTimestamp()
    }, {
      merge: true
    });
  };

  var notifySource = function notifySource(target, content) {
    db.collection("" + (config === null || config === void 0 ? void 0 : config.provider)).doc("notifications").collection("" + user.id).doc("" + target.id).set({
      lastMessage: content,
      timestamp: connection.firestore.FieldValue.serverTimestamp()
    }, {
      merge: true
    });
  };

  var removeTargetNotification = function removeTargetNotification(target) {
    db.collection("" + (config === null || config === void 0 ? void 0 : config.provider)).doc("notifications").collection("" + user.id).doc("" + target.id).set({
      counter: 0,
      activeNotification: false
    }, {
      merge: true
    });
  };

  var sendMessage = function sendMessage(content, target) {
    try {
      var channel = getChannel(target);

      var _temp2 = _catch(function () {
        return Promise.resolve(db.collection((config === null || config === void 0 ? void 0 : config.provider) + "/conversations/" + channel).add({
          content: content,
          timestamp: connection.firestore.FieldValue.serverTimestamp(),
          source: user.id,
          target: target.id
        })).then(function () {
          notifyTarget(target, content);
          notifySource(target, content);
        });
      }, function (error) {
        setErrors([].concat(errors, [{
          writeError: error
        }]));
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  useEffect(function () {
    createNotificationListener();
  }, [createNotificationListener]);
  useEffect(function () {
    getContacts();
  }, []);
  return React.createElement(firebaseChatContext.Provider, {
    value: {
      sendMessage: sendMessage,
      contacts: contacts,
      onMessage: onMessage,
      getChannel: getChannel,
      notifyTarget: notifyTarget,
      notifications: notifications,
      hasAlert: hasAlert,
      counterAlert: counterAlert,
      removeTargetNotification: removeTargetNotification,
      user: user,
      conversations: conversations,
      connection: connection,
      oneContact: oneContact,
      provider: provider
    }
  }, children);
};

var _templateObject;

var Button = function Button(_ref) {
  var className = _ref.className,
      handleClick = _ref.handleClick,
      open = _ref.open;

  var _useContext = useContext(firebaseChatContext),
      hasAlert = _useContext.hasAlert,
      counterAlert = _useContext.counterAlert;

  return React.createElement("button", {
    className: className,
    onClick: handleClick
  }, open ? React.createElement(FontAwesomeIcon, {
    icon: faTimes
  }) : React.createElement(FontAwesomeIcon, {
    icon: faCommentDots
  }), hasAlert() && React.createElement("span", {
    className: "chat-alert"
  }, counterAlert()));
};

var Button$1 = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  z-index: 9999999999;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 60px;\n  width: 60px;\n  background: ", ";\n  border-radius: 50%;\n  box-shadow: 2px 2px 3px 3px rgba(0, 0, 0, 0.08);\n\n  svg {\n    color: #fff;\n    height: 28px !important;\n    width: 28px !important;\n  }\n\n  .chat-alert {\n    position: fixed;\n    bottom: 60px;\n    right: 19px;\n    z-index: 99999999999;\n\n    height: 15px !important;\n    width: 15px !important;\n    border-radius: 50% !important;\n\n    background: #95190c;\n\n    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);\n    transform: scale(1);\n    animation: pulse 2s infinite;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 8px;\n\n    @keyframes pulse {\n      0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);\n      }\n\n      70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);\n      }\n\n      100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);\n      }\n    }\n  }\n"])), function (props) {
  return props.theme.primaryColor;
});

var _templateObject$1;

var Avatar = function Avatar(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement("div", {
    className: className
  }, React.createElement(FontAwesomeIcon, {
    icon: faUser
  }), children);
};

var Avatar$1 = styled(Avatar)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex-shrink: 0;\n  margin-left: 12px;\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n  background: #faf9f8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    height: 18px !important;\n    width: 18px !important;\n    color: #768190;\n  }\n"])));

var _templateObject$2;

var Header = function Header(_ref) {
  var className = _ref.className,
      title = _ref.title,
      back = _ref.back,
      handleClick = _ref.handleClick,
      _ref$hasMenu = _ref.hasMenu,
      hasMenu = _ref$hasMenu === void 0 ? false : _ref$hasMenu;
  return React.createElement("header", {
    className: className
  }, hasMenu ? React.createElement("div", {
    className: "menu__button"
  }, React.createElement("button", {
    className: "button__conversation",
    onClick: function onClick() {
      return handleClick('CONVERSATION');
    }
  }, "Conversas"), React.createElement("button", {
    className: "button__contacts",
    onClick: function onClick() {
      return handleClick('CONTACTS');
    }
  }, "Contatos")) : React.createElement("div", {
    className: "menu__normal"
  }, back && React.createElement(FontAwesomeIcon, {
    icon: faArrowLeft,
    className: "__back",
    onClick: handleClick
  }), React.createElement(Avatar$1, null), React.createElement("div", {
    className: "wrapper__title"
  }, React.createElement("div", {
    className: "__title"
  }, title))));
};

var Header$1 = styled(Header)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  color: #fff;\n  border-radius: 8px 8px 0 0;\n  background: ", ";\n  display: flex;\n  align-items: center;\n\n  .menu__normal {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    border-radius: 8px 8px 0 0;\n  }\n\n  .__back {\n    margin-left: 12px;\n    cursor: pointer;\n    transition: filter 500ms;\n    height: 15px !important;\n    width: 15px !important;\n\n    &:hover {\n      filter: brightness(70%);\n    }\n  }\n\n  .wrapper__title {\n    margin-left: 12px;\n\n    .__title {\n      font-weight: 600;\n      font-size: 14px;\n    }\n  }\n\n  .menu__button {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-radius: 8px 8px 0 0;\n\n    button {\n      border: none;\n      font: inherit;\n      cursor: pointer;\n      outline: inherit !important;\n      height: 100%;\n      width: 50%;\n      font-weight: 600;\n      font-size: 14px;\n      color: #fff;\n      transition: filter 500ms;\n\n      &:hover {\n        filter: brightness(95%);\n      }\n      \n      &:nth-child(odd) {\n        border-radius: 8px 0 0 0 ;\n      }\n\n      &:nth-child(even) {\n        border-radius: 0 8px 0 0 ;\n      }\n    }\n\n    .button__conversation {\n      background: ", ";\n    }\n\n    .button__contacts {\n      background: ", ";\n    }\n\n\n  }\n"])), function (props) {
  return props.theme.primaryColor;
}, function (props) {
  switch (props.buttonFocus) {
    case 'CONVERSATION':
      return props.theme.primaryColor;

    case 'CONTACTS':
      return props.theme.secondaryColor;
  }
}, function (props) {
  switch (props.buttonFocus) {
    case 'CONTACTS':
      return props.theme.primaryColor;

    case 'CONVERSATION':
      return props.theme.secondaryColor;
  }
});

var _templateObject$3;

var Input = function Input(_ref) {
  var className = _ref.className,
      contact = _ref.contact,
      fileImport = _ref.fileImport;

  var _useState = useState(''),
      newMessage = _useState[0],
      setNewMessage = _useState[1];

  var _useContext = useContext(firebaseChatContext),
      sendMessage = _useContext.sendMessage;

  var _useState2 = useState(1),
      rows = _useState2[0],
      setRows = _useState2[1];

  var handleMessage = function handleMessage(e) {
    e.preventDefault();

    if (newMessage.length) {
      setNewMessage('');
      setRows(1);
      sendMessage(newMessage, contact);
    }
  };

  var onKeyPress = function onKeyPress(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      handleMessage(e);
    }
  };

  var handleChange = function handleChange(e) {
    var minRows = 1;
    var maxRows = 5;
    var textareaLineHeight = 20;
    var previousRows = e.target.rows;
    e.target.rows = minRows;
    var currentRows = ~~(e.target.scrollHeight / textareaLineHeight);

    if (currentRows === previousRows) {
      e.target.rows = currentRows;
    }

    if (currentRows >= maxRows) {
      e.target.rows = maxRows;
      e.target.scrollTop = e.target.scrollHeight;
    }

    setNewMessage(e.target.value);
    setRows(currentRows < maxRows ? currentRows : maxRows);
  };

  return React.createElement("form", {
    className: className
  }, React.createElement("textarea", {
    rows: rows,
    value: newMessage,
    placeholder: 'Escreva algo...',
    onChange: handleChange,
    onKeyPress: onKeyPress
  }), newMessage.length !== 0 ? React.createElement("button", {
    onClick: handleMessage
  }, React.createElement(FontAwesomeIcon, {
    icon: faAngleRight
  })) : React.createElement("button", {
    onClick: fileImport
  }, React.createElement(FontAwesomeIcon, {
    icon: faPaperclip
  })));
};

var Input$1 = styled(Input)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  margin: 0;\n  textarea {\n    box-sizing: border-box;\n    display: block;\n    min-height: 35px;\n    line-height: 20px;\n    width: 326px;\n    border-radius: 4px;\n    border: none;\n    font-size: 14px;\n    color: #768190;\n    resize: none;\n    padding: 8px 38px 0 15px;\n\n    &:focus {\n      outline: none;\n      padding: 8px 38px 0 15px;\n    }\n\n    ::-webkit-scrollbar {\n      display: unset;\n      width: 5px;\n    }\n    ::-webkit-scrollbar-thumb {\n      background-color: lightgray;\n      border-radius: 4px;\n      cursor: pointer;\n    }\n    ::-webkit-scrollbar-track {\n      background-color: transparent;\n    }\n  }\n\n  button {\n    position: absolute;\n    right: 22px;\n    bottom: 14px;\n    background: none;\n    color: inherit;\n    border: none;\n    padding: 0;\n    font: inherit;\n    cursor: pointer;\n    outline: inherit !important;\n\n\n    svg {\n      height: 17px !important;\n      width: 17px !important;\n      color: #c3c3c3;\n      transition: filter 500ms;\n\n      &:hover {\n        filter: brightness(90%);\n      }\n    }\n  }\n"])));

var _templateObject$4;

var Footer = function Footer(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement("footer", {
    className: className
  }, children);
};

var Footer$1 = styled(Footer)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  margin-top: 0 !important;\n  background: ", ";\n  padding: 8px;\n  border-radius: 0 0 8px 8px;\n  display: block;\n"])), function (props) {
  return props.theme.primaryColor;
});

var _templateObject$5;

var CardUser = function CardUser(_ref) {
  var _notification$content, _notification$content2, _notification$content3, _notification$content4;

  var className = _ref.className,
      contact = _ref.contact,
      onClick = _ref.onClick,
      notification = _ref.notification;

  var handleClick = function handleClick() {
    onClick(contact);
  };

  return React.createElement("div", {
    className: className,
    onClick: handleClick
  }, React.createElement(Avatar$1, null, (notification === null || notification === void 0 ? void 0 : (_notification$content = notification.content) === null || _notification$content === void 0 ? void 0 : _notification$content.activeNotification) && React.createElement("span", {
    className: "inbox__notification"
  }, (notification === null || notification === void 0 ? void 0 : (_notification$content2 = notification.content) === null || _notification$content2 === void 0 ? void 0 : _notification$content2.counter) > 0 && (notification === null || notification === void 0 ? void 0 : (_notification$content3 = notification.content) === null || _notification$content3 === void 0 ? void 0 : _notification$content3.counter))), React.createElement("div", {
    className: "wrapper__text"
  }, React.createElement("div", {
    className: "__username"
  }, contact.name), React.createElement("div", {
    className: "__last-message"
  }, notification === null || notification === void 0 ? void 0 : (_notification$content4 = notification.content) === null || _notification$content4 === void 0 ? void 0 : _notification$content4.lastMessage)));
};

var CardUser$1 = styled(CardUser)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.08);\n  min-height: 65px;\n  background: #fff;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: #768190;\n  width: 100%;\n  cursor: pointer;\n  transition: filter 500ms;\n\n  &:hover {\n    filter: brightness(95%);\n  }\n\n  .inbox__notification {\n    height: 14px;\n    width: 14px;\n    background: #95190c;\n    border-radius: 50%;\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    flex-shrink: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-size: 8px;\n\n  }\n\n  .wrapper__text {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-left: 12px;\n    height: 35px;\n\n    .__username {\n      font-weight: bold;\n      font-size: 12px;\n      max-width: 200px;\n    }\n\n    .__last-message {\n      white-space: nowrap; \n      overflow: hidden;\n      font-size: 9px;\n      max-width: 200px;\n      text-overflow: ellipsis;\n    }\n\n  }\n\n"])));

var _templateObject$6;

var Skeleton = function Skeleton(_ref) {
  var className = _ref.className,
      height = _ref.height,
      width = _ref.width;
  return React.createElement("section", {
    className: className,
    style: {
      height: height,
      width: width
    }
  });
};

var Skeleton$1 = styled(Skeleton)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  margin-top: 15px;\n  border-radius: 8px;\n  background-image: linear-gradient(\n    -90deg,\n    #e7edf1 0%,\n    #f8f8f8 50%,\n    #e7edf1 100%\n  );\n  background-size: 400% 400%;\n  animation: shimmer 1.2s ease-in-out infinite;\n  @keyframes shimmer {\n    0% {\n      background-position: 0% 0%;\n    }\n    100% {\n      background-position: -135% -0%;\n    }\n  }\n  &:white {\n    background-image: linear-gradient(-90deg, #fff 0%, #e7edf1 50%, #fff 100%);\n  }\n"])));

var _templateObject$7;

var Body = function Body(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React.createElement("section", {
    className: className
  }, children);
};

var Body$1 = styled(Body)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  background: #faf9f8;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 4px;\n  }\n  ::-webkit-scrollbar-track {\n    border-radius: 0 8px 8px 0;\n  }\n\n  .wrapper-other {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 18px;\n  }\n"])), function (props) {
  return props.theme.secondaryColor;
});

var _templateObject$8;

var SearchCard = function SearchCard(_ref) {
  var className = _ref.className,
      filter = _ref.filter;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  useEffect(function () {
    filter(inputValue);
  }, [inputValue]);
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "search__wrapper"
  }, React.createElement("input", {
    placeholder: "Pesquisar...",
    value: inputValue,
    onChange: function onChange(e) {
      return setInputValue(e.target.value);
    }
  }), React.createElement(FontAwesomeIcon, {
    icon: faSearch
  })));
};

var SearchCard$1 = styled(SearchCard)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.08);\n  height: 45px;\n  background: #fff;\n  margin-bottom: 10px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #768190;\n  width: 100%;\n  \n  .search__wrapper {\n    width: 85%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    svg {\n        height: 15px;\n        width: 15px;\n    }\n\n    input {\n        color: #768190;\n        font-weight: 500;\n        font-size: 12px;\n        width: 200px;\n        height: 28px;\n        border-radius: 4px;\n        background: #faf9f8;\n        border: none;\n        padding: 0 20px;\n\n        &:focus {\n        outline: none;\n        }\n        &::placeholder {\n            color: #c4c4c4;\n        }\n    }\n  }\n\n\n"])));

var lowerCaseStringAndRemoveAccent = function lowerCaseStringAndRemoveAccent(value) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};

var _templateObject$9;

var ListUsers = function ListUsers(_ref) {
  var className = _ref.className,
      handleClick = _ref.handleClick,
      contacts = _ref.contacts,
      type = _ref.type;

  var _useContext = useContext(firebaseChatContext),
      notifications = _useContext.notifications;

  var _useState = useState(undefined),
      currentContact = _useState[0],
      setCurrentContact = _useState[1];

  var _useState2 = useState([]),
      contactsFiltered = _useState2[0],
      setContactsFiltered = _useState2[1];

  useEffect(function () {
    if (currentContact) {
      handleClick(currentContact);
    }
  }, [currentContact]);

  var filterContacts = function filterContacts(searchInput) {
    lowerCaseStringAndRemoveAccent(searchInput);
    setContactsFiltered(contacts === null || contacts === void 0 ? void 0 : contacts.filter(function (contact) {
      var _lowerCaseStringAndRe;

      return (_lowerCaseStringAndRe = lowerCaseStringAndRemoveAccent(contact === null || contact === void 0 ? void 0 : contact.name)) === null || _lowerCaseStringAndRe === void 0 ? void 0 : _lowerCaseStringAndRe.includes(lowerCaseStringAndRemoveAccent(searchInput));
    }));
  };

  return React.createElement(Body$1, {
    className: className
  }, contacts === undefined ? React.createElement("div", null, React.createElement(Skeleton$1, {
    height: '65px',
    width: '95%'
  }), React.createElement(Skeleton$1, {
    height: '65px',
    width: '95%'
  }), React.createElement(Skeleton$1, {
    height: '65px',
    width: '95%'
  })) : React.createElement("div", null, (contacts === null || contacts === void 0 ? void 0 : contacts.length) === 0 ? React.createElement("div", {
    className: "empty__conversation"
  }, "Voc\xEA n\xE3o tem nenhuma conversa ainda, que tal iniciar uma?") : React.createElement("div", null, (contacts === null || contacts === void 0 ? void 0 : contacts.length) > 1 && type === 'CONTACTS' ? React.createElement("div", null, React.createElement(SearchCard$1, {
    filter: filterContacts
  }), contactsFiltered === null || contactsFiltered === void 0 ? void 0 : contactsFiltered.map(function (contact) {
    var notifier = notifications.find(function (x) {
      var _contact$id;

      return x.id === (contact === null || contact === void 0 ? void 0 : (_contact$id = contact.id) === null || _contact$id === void 0 ? void 0 : _contact$id.toString());
    });
    return React.createElement(CardUser$1, {
      key: contact.id,
      notification: notifier,
      contact: contact,
      onClick: setCurrentContact
    });
  })) : React.createElement("div", null, contacts.map(function (contact) {
    var notifier = notifications.find(function (x) {
      var _contact$id2;

      return x.id === (contact === null || contact === void 0 ? void 0 : (_contact$id2 = contact.id) === null || _contact$id2 === void 0 ? void 0 : _contact$id2.toString());
    });
    return React.createElement(CardUser$1, {
      key: contact.id,
      notification: notifier,
      contact: contact,
      onClick: setCurrentContact
    });
  })))));
};

var ListContact = styled(ListUsers)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n\n  .empty__conversation {\n    margin: 20px 5px 5px 5px;\n    color: #c4c4c4;\n  }\n\n"])));

var formatTimeStamp = function formatTimeStamp(timestamp) {
  var a = new Date(timestamp * 1000);
  return a.toLocaleDateString("pt-br", {
    hour: "numeric",
    minute: "numeric"
  });
};

var _templateObject$a;

var Time = function Time(_ref) {
  var className = _ref.className,
      time = _ref.time;
  var inboxRef = useRef(null);

  if (inboxRef.current) {
    inboxRef.current.scrollIntoView({
      behavior: "smooth"
    });
  }

  return React.createElement("div", {
    className: className,
    ref: inboxRef
  }, formatTimeStamp(time));
};

var Time$1 = styled(Time)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: ", ";\n  font-size: 10px;\n  margin-top: 4px;\n  color: #768190;\n"])), function (props) {
  return props.source === "me" ? "flex-end" : "flex-start";
});

var _templateObject$b;

var MessageImage = function MessageImage(_ref) {
  var className = _ref.className,
      image = _ref.image;

  var showImage = function showImage(documentUrl) {
    var link = document.createElement("a");
    link.href = documentUrl;
    link.target = "_blank";
    link.click();
  };

  return React.createElement("img", {
    className: className,
    src: image,
    alt: "message-image",
    onClick: function onClick() {
      return showImage(image);
    }
  });
};

var MessageImage$1 = styled(MessageImage)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n  width: 180px;\n  margin: 10px;\n  object-fit: contain;\n  cursor: pointer;\n"])));

var _templateObject$c;

var Message = function Message(_ref) {
  var className = _ref.className,
      message = _ref.message;
  return React.createElement("div", {
    className: className
  }, message);
};

var Message$1 = styled(Message)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  padding: 10px;\n  max-width: 200px;\n  font-size: 12px;\n  word-wrap: break-word;\n"])));

var _templateObject$d;

var CardMessage = function CardMessage(_ref) {
  var className = _ref.className,
      message = _ref.message,
      source = _ref.source;

  var verifyHostName = function verifyHostName(url) {
    return url.indexOf("https://firebasestorage") !== -1;
  };

  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "container__message"
  }, React.createElement("div", {
    className: "__message"
  }, verifyHostName(message === null || message === void 0 ? void 0 : message.content) ? React.createElement(MessageImage$1, {
    image: message === null || message === void 0 ? void 0 : message.content
  }) : React.createElement(Message$1, {
    message: message.content
  })), message.timestamp && React.createElement(Time$1, {
    time: message.timestamp.seconds,
    source: source
  })));
};

var CardMessage$1 = styled(CardMessage)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  text-align: ", ";\n  justify-content: ", ";\n  margin-bottom: 18px;\n\n  .container__message {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    .__message {\n      color: ", ";\n      background: ", ";\n      border-radius: ", ";\n      box-shadow: 2px 2px 3px 3px rgba(0, 0, 0, 0.08);\n    }\n  }\n"])), function (props) {
  return props.source === "me" ? "end" : "start";
}, function (props) {
  return props.source === "me" ? "flex-end" : "flex-start";
}, function (props) {
  return props.source === "me" ? props.theme.messageMeColor : props.theme.messageOtherColor;
}, function (props) {
  return props.source === "me" ? props.theme.messageMeBackground : props.theme.messageOtherBackground;
}, function (props) {
  return props.source === "me" ? "12px 0 12px 12px" : "12px 12px 12px 0";
});

var _templateObject$e;

var MessageSkeleton = function MessageSkeleton(_ref) {
  var className = _ref.className;
  return React.createElement("section", {
    className: className
  }, React.createElement(Skeleton$1, {
    height: "50px",
    width: "150px"
  }), React.createElement(Skeleton$1, {
    height: "50px",
    width: "150px"
  }), React.createElement(Skeleton$1, {
    height: "50px",
    width: "150px"
  }), React.createElement(Skeleton$1, {
    height: "50px",
    width: "150px"
  }), React.createElement(Skeleton$1, {
    height: "50px",
    width: "150px"
  }), React.createElement(Skeleton$1, {
    height: "50px",
    width: "150px"
  }));
};

var MessageSkeleton$1 = styled(MessageSkeleton)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n\n  section:nth-child(2n + 1) {\n    margin-left: 160px;\n  }\n"])));

var _templateObject$f;

var Messages = function Messages(_ref) {
  var className = _ref.className,
      contact = _ref.contact;

  var _useContext = useContext(firebaseChatContext),
      user = _useContext.user,
      getChannel = _useContext.getChannel,
      onMessage = _useContext.onMessage,
      removeTargetNotification = _useContext.removeTargetNotification;

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState([]),
      messages = _useState2[0],
      setMessages = _useState2[1];

  useEffect(function () {
    {
      (messages === null || messages === void 0 ? void 0 : messages.length) === 0 && setIsLoading(true);
    }
    var unsub = onMessage(function (mes) {
      setMessages(mes);
      removeTargetNotification(contact);
      setIsLoading(false);
    }, getChannel(contact));
    return function () {
      return unsub();
    };
  }, [contact, getChannel, onMessage, removeTargetNotification]);
  return React.createElement(Body$1, {
    className: className
  }, isLoading && React.createElement(MessageSkeleton$1, null), messages.map(function (message, i) {
    var source = message.source === user.id ? "me" : "other";
    return React.createElement(CardMessage$1, {
      isLoading: isLoading,
      source: source,
      key: i,
      message: message
    });
  }));
};

var Messages$1 = styled(Messages)(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  padding: 20px;\n"])));

var _templateObject$g;

var ImagePreview = function ImagePreview(_ref) {
  var className = _ref.className,
      url = _ref.url;
  return React.createElement("img", {
    src: url,
    alt: "preview image",
    className: className
  });
};

var ImagePreview$1 = styled(ImagePreview)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n    width: 250px;\n    max-height: 350px;\n"])));

var generateRandomNumber = function generateRandomNumber(max, min) {
  return Math.random() * (max - min) + min;
};

var _templateObject$h;

var Error = function Error(_ref) {
  var className = _ref.className,
      title = _ref.title;
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "error__container"
  }, React.createElement("div", {
    className: "error__border"
  }, React.createElement("p", null, title))));
};

var Error$1 = styled(Error)(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  top: 50px;\n  height: 100px;\n  width: 100%;\n  position: absolute;\n  z-index: 9999999999999999;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .error__container {\n    width: 80%;\n    height: 80%;\n    background: #95190c;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .error__border {\n      width: 90%;\n      height: 80%;\n      border-radius: 8px;\n      border: 1px dashed #fff;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      p {\n        color: #fff;\n        margin-top: 20px;\n        font-size: 12px;\n      }\n    }\n  }\n"])));

var _templateObject$i;

var FileImport = function FileImport(_ref) {
  var className = _ref.className,
      handleClose = _ref.handleClose,
      contact = _ref.contact;

  var _useState = useState(null),
      selectedFile = _useState[0],
      setSelectedFile = _useState[1];

  var _useState2 = useState(""),
      selectedUrl = _useState2[0],
      setSelectedUrl = _useState2[1];

  var _useContext = useContext(firebaseChatContext),
      user = _useContext.user,
      sendMessage = _useContext.sendMessage,
      connection = _useContext.connection,
      provider = _useContext.provider;

  var allowedMimeTypes = ["image/jpeg", "image/png"];
  var fileSizeLimit = 1024 * 1024 * 10;

  var _useState3 = useState(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var _useState4 = useState({
    error: false,
    motive: ""
  }),
      error = _useState4[0],
      setError = _useState4[1];

  var storage = connection.storage();

  var onFileChange = function onFileChange(event) {
    var file = event.target.files[0];
    var url = window.URL.createObjectURL(file);

    if (file.size < fileSizeLimit) {
      if (allowedMimeTypes.includes(file.type)) {
        setSelectedUrl(url);
        setSelectedFile(file);
      } else {
        return setError({
          error: true,
          motive: "Este formato não é suportado."
        });
      }
    } else {
      return setError({
        error: true,
        motive: "O tamanho do arquivo deverá ser menor que 10Mb"
      });
    }
  };

  var getImageUrl = function getImageUrl() {
    try {
      var imageRef = storage.ref().child(provider + "/" + user.id + "/" + generateRandomNumber(99999999999999, 1) + selectedFile.name);
      return Promise.resolve(imageRef.put(selectedFile)).then(function (_imageRef$put) {
        return Promise.resolve(_imageRef$put.ref.getDownloadURL());
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  var handleClick = function handleClick(e) {
    try {
      e.preventDefault();
      setIsLoading(true);
      return Promise.resolve(getImageUrl()).then(function (_getImageUrl) {
        sendMessage(_getImageUrl, contact);
        handleClose(e);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return React.createElement("div", null, error.error && React.createElement(Error$1, {
    title: error.motive
  }), React.createElement("form", {
    className: className,
    onSubmit: handleClick
  }, React.createElement("header", null, React.createElement(FontAwesomeIcon, {
    icon: faTimes,
    size: "2x",
    onClick: handleClose
  })), React.createElement("section", null, isLoading ? React.createElement("div", null, React.createElement(FontAwesomeIcon, {
    icon: faSpinner,
    spin: true,
    size: "2x"
  })) : React.createElement("div", null, selectedFile ? React.createElement("div", null, React.createElement(ImagePreview$1, {
    url: selectedUrl
  }), React.createElement("button", {
    type: "submit"
  }, React.createElement(FontAwesomeIcon, {
    icon: faAngleRight
  }))) : React.createElement("main", null, React.createElement("div", null, React.createElement("p", {
    className: '__p'
  }, "Arraste"), React.createElement("p", {
    className: '__p'
  }, "ou"), React.createElement("label", {
    htmlFor: "select-file"
  }, "Clique aqui"), React.createElement("input", {
    type: "file",
    id: "select-file",
    onChange: onFileChange
  })))))));
};

var FileImport$1 = styled(FileImport)(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  z-index: 99999999999;\n\n  header {\n    z-index: 1;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 55px;\n\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    color: #fff;\n    background: transparent;\n\n    svg {\n      margin-right: 20px;\n      cursor: pointer;\n      transition: filter 500ms;\n\n      &:hover {\n        filter: brightness(70%);\n      }\n    }\n  }\n\n  section {\n    color: #fff;\n    position: absolute;\n    height: 100%;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: transparent;\n\n    button {\n      z-index: 1;\n      background: #faf9f8;\n      border: none;\n      padding: 0;\n      font: inherit;\n      cursor: pointer;\n      outline: inherit !important;\n      bottom: 20px;\n      right: 20px;\n      position: absolute;\n\n      height: 30px;\n      width: 30px;\n      border-radius: 50%;\n      color: #3b5a86;\n      transition: filter 500ms;\n\n      &:hover {\n        filter: brightness(80%);\n      }\n    }\n\n    main {\n      height: 220px;\n      width: 220px;\n      border-radius: 16px;\n      border: dashed 10px white;\n\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      div {\n        font-size: 21px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        height: 60%;\n        align-items: center;\n\n        p {\n            margin-top: 0;\n          }\n\n        input[type=\"file\"] {\n          display: none;\n        }\n\n        label {\n          font-size: 21px;\n          color: #fff;\n          font-weight: bold;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"])));

var _templateObject$j;

var Inbox = function Inbox(_ref) {
  var className = _ref.className;

  var _useState = useState(false),
      showFileImport = _useState[0],
      setShowFileImport = _useState[1];

  var _useState2 = useState(false),
      showMessages = _useState2[0],
      setShowMessages = _useState2[1];

  var _useState3 = useState(undefined),
      contact = _useState3[0],
      setContact = _useState3[1];

  var _useState4 = useState('CONVERSATION'),
      listChoice = _useState4[0],
      setListChoice = _useState4[1];

  var _useContext = useContext(firebaseChatContext),
      contacts = _useContext.contacts,
      conversations = _useContext.conversations,
      oneContact = _useContext.oneContact;

  var handleOpenMessages = function handleOpenMessages(currentContact) {
    setShowMessages(true);
    setContact(currentContact);
  };

  var handleBackToListContact = function handleBackToListContact() {
    setShowMessages(false);
  };

  var handleOpenFileImport = function handleOpenFileImport(e) {
    e.preventDefault();
    setShowFileImport(!showFileImport);
  };

  var handleChoiceList = function handleChoiceList(value) {
    setListChoice(value);
  };

  return React.createElement("div", {
    className: className
  }, showFileImport && React.createElement(FileImport$1, {
    handleClose: handleOpenFileImport,
    contact: oneContact ? contacts[0] : contact
  }), !showMessages && !oneContact ? React.createElement("div", {
    className: "wrapper__body"
  }, React.createElement(Header$1, {
    hasMenu: true,
    handleClick: handleChoiceList,
    buttonFocus: listChoice
  }), listChoice === 'CONTACTS' ? React.createElement(ListContact, {
    handleClick: handleOpenMessages,
    contacts: contacts,
    type: "CONTACTS"
  }) : React.createElement(ListContact, {
    handleClick: handleOpenMessages,
    contacts: conversations,
    type: "CONVERSATIONS"
  }), React.createElement("div", {
    className: "__space"
  }, React.createElement(Footer$1, null))) : React.createElement("div", {
    className: "wrapper__body"
  }, React.createElement(Header$1, {
    title: oneContact ? contacts[0].name : contact.name,
    back: oneContact ? false : true,
    handleClick: handleBackToListContact
  }), React.createElement(Messages$1, {
    contact: oneContact ? contacts[0] : contact
  }), React.createElement("div", {
    className: "__space"
  }, React.createElement(Footer$1, null, React.createElement(Input$1, {
    contact: oneContact ? contacts[0] : contact,
    fileImport: handleOpenFileImport
  })))));
};

var Inbox$1 = styled(Inbox)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n  \n  position: fixed;\n  bottom: 100px;\n  right: 20px;\n  z-index: 9999999999 !important;\n\n\n  .wrapper__body {\n    font-family: ", ";\n    box-shadow: 2px 2px 3px 3px rgba(0, 0, 0, 0.08);\n    border-radius: 8px;\n    width: 346px;\n    background: #faf9f8;\n    height: 550px;\n    display: grid;\n    grid-template-rows: 55px auto auto;\n  }\n\n\n  .__space {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n\n"])), function (props) {
  return props.theme.fontFamily;
});

var Chat = function Chat(_ref) {
  var contacts = _ref.contacts,
      user = _ref.user,
      connection = _ref.connection,
      config = _ref.config;

  var _useState = useState(false),
      showInbox = _useState[0],
      setShowInbox = _useState[1];

  var handleOpenPopup = function handleOpenPopup() {
    setShowInbox(!showInbox);
  };

  return React.createElement(FirebaseChatContextProvider, {
    users: contacts,
    user: user,
    connection: connection,
    config: config
  }, React.createElement("div", null, React.createElement(Button$1, {
    handleClick: handleOpenPopup,
    open: showInbox
  }), showInbox && React.createElement(Inbox$1, null)));
};

var Theme = function Theme(_ref) {
  var children = _ref.children,
      themeProvider = _ref.themeProvider;
  return React.createElement(ThemeProvider, {
    theme: themeProvider
  }, children);
};

var themes;
var users = [];
var user;
var config;
var params;

var listUsers = function listUsers(value) {
  return users = value;
};

var currentUser = function currentUser(value) {
  return user = value;
};

var chatTheme = function chatTheme(value) {
  return themes = value;
};

var connectionConfig = function connectionConfig(value) {
  return config = value;
};

var chatConfig = function chatConfig(value) {
  return params = value;
};

var Educhat = function Educhat() {
  if (!firebase.apps.length) {
    firebase.initializeApp(config);
  } else {
    firebase.app();
  }

  return React.createElement(Theme, {
    themeProvider: themes
  }, React.createElement(Chat, {
    contacts: users,
    user: user,
    connection: firebase,
    config: params
  }));
};

export default Educhat;
export { chatConfig, chatTheme, connectionConfig, currentUser, listUsers };